import React from "react";

import JSONPretty from "react-json-pretty";
import * as JSONPrettyMon from "react-json-pretty/dist/monikai";

const JSONDescription = ({ description }) => {
  const stringifiedDescription = JSON.stringify(description);

  return (
    <div className="w-5/6 overflow-auto">
      <JSONPretty
        id="json-pretty"
        style={{
          fontSize: "12px",
        }}
        mainStyle="padding:1em;height:80vh"
        theme={JSONPrettyMon}
        data={stringifiedDescription}
      />
    </div>
  );
};
export default JSONDescription;
